// @flow
import * as React from 'react'
import { Container } from './elements'

/**
 * Component for handling option clicks and focus state.
 * Provides a way to render the option with given option
 * renderer and option wrapper and render some specific
 * thing when the option focused.
 */
class OptionItem extends React.Component<any, any> {
  static defaultProps = {
    renderOption: (x: any) => x,
    OptionWrapper: 'div',
  }

  handleClick = () => {
    const { onClick, value, index } = this.props
    if (onClick) onClick(value, index)
  }

  handleMouseUp = (e: any) => {
    e.preventDefault()
  }

  render() {
    const {
      focused,
      renderOption,
      index,
      value,
      style,
      OptionWrapper,
    } = this.props

    return React.isValidElement(value) ? (
      value
    ) : (
      <Container
        $as={OptionWrapper}
        style={style}
        onClick={this.handleClick}
        onMouseDown={this.handleMouseUp}
        $focused={focused}
      >
        {renderOption(value, { focused, index })}
      </Container>
    )
  }
}

export default OptionItem
